import React from 'react';
import './BannerButtons.css';
import { ReactComponent as ArrowDownIcon } from '../../images/arrow-down.svg'
import { ReactComponent as GithubIcon } from '../../images/github.svg'

function BannerButtons() {
    function scrollToProjects() {
        var elem = document.getElementById('projects');
        if (elem) {
            elem.scrollIntoView({ block: "start" });
        }
    }

    return (
        <div className="banner-buttons-container">
            <nav>
                <ul>
                    <li>
                        <button className="banner-buttons" id="projects-button" onClick={scrollToProjects}>
                            <span>My Projects</span>
                            <ArrowDownIcon />
                        </button>
                    </li>
                    <li>
                        <a href="https://github.com/timii" target="_blank" rel="noreferrer" aria-label='Go to my GitHub'>
                            <button className="banner-buttons" id="github-button">
                                <span>Go to my GitHub</span>
                                <GithubIcon />
                            </button>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default BannerButtons;